import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys } from '~/routes/app-paths';

const EARNINGS_INSIGHT_DRAWER_ID = 'earningsInsight';

export enum SubTabsType {
  Preview = 'preview',
  Recap = 'recap',
}

export const useEarningsInsightDrawer = () => {
  const { deleteQueryParam, setQueryParams, params } = useQueryParams();
  const isDrawerOpen =
    params[queryKeys.activeDrawer] === EARNINGS_INSIGHT_DRAWER_ID;
  const activeEntityTag = params[queryKeys.activeEarningsEntity];
  const earningsId = params[queryKeys.earningsId];

  const subtabs = [SubTabsType.Preview, SubTabsType.Recap];
  const foundTabIndex = subtabs.findIndex(
    tab => tab === params[queryKeys.activeDrawerTab]
  );
  const activeTabIndex = foundTabIndex !== -1 ? foundTabIndex : 0;
  const activeTab = subtabs[activeTabIndex];

  const openDrawer = ({
    entityTag,
    earningsId,
    subtab,
  }: {
    entityTag: string;
    earningsId: string;
    subtab?: SubTabsType;
  }) =>
    setQueryParams({
      [queryKeys.activeDrawer]: EARNINGS_INSIGHT_DRAWER_ID,
      [queryKeys.activeDrawerTab]: subtab ?? SubTabsType.Preview,
      [queryKeys.activeEarningsEntity]: entityTag,
      [queryKeys.earningsId]: earningsId,
    });

  const closeDrawer = () =>
    deleteQueryParam([
      queryKeys.activeDrawer,
      queryKeys.activeDrawerTab,
      queryKeys.activeEarningsEntity,
      queryKeys.earningsId,
    ]);

  const switchTab = (index: number) => {
    setQueryParams({ [queryKeys.activeDrawerTab]: subtabs[index] });
  };

  return {
    closeDrawer,
    openDrawer,
    isDrawerOpen,
    activeEntityTag,
    switchTab,
    activeTabIndex,
    activeTab,
    earningsId,
  };
};
